import { getSettingsSettingsApi as generatedGetSettingsSettingsApi } from '../generated/settings/getSettingsSettings';

const getSettingsSettingsApi = generatedGetSettingsSettingsApi.enhanceEndpoints({
  endpoints: {
    getSettingsSettings: {
      providesTags: ['Settings'],
    },
  },
});

export const { useGetSettingsSettingsQuery } = getSettingsSettingsApi;
